import s from "./BodyEdit.module.css";
import {useEffect, useState} from "react";
import {useAddAlert} from "@/hooks/useAddAlert";
import Textarea from '../../../UI/Textarea';
import {CheckBoxLabel} from "@UI/CheckBox";
import { classApi } from "@/api";
import Button from "@UI/New/Button";
import { useDispatch } from "react-redux";
import { closePreloader, openPreloader } from "@store/preloaderSlice";

const MIN_DELETE_PRELOADER_DELAY = 1500

const waitMinDeletePreloaderDelay = () =>
  new Promise((resolve) => setTimeout(resolve, MIN_DELETE_PRELOADER_DELAY))

const ModalRemoveClass = ({elClass, user_id, setClasses, fetchClasses, closeModal}) => {
  const dispatch = useDispatch()
  const addAlert = useAddAlert();
  const [disabledByStudent, setDisabledByStudent] = useState(false);
  const [keepUncompletedHomework, setKeepUncompletedHomework] = useState(true)
  const [disableComment, setDisableComment] = useState('');
  const [removing, setRemoving] = useState(false);

  const removeClass = () => {
    if (removing) return

    setRemoving(true)
    dispatch(openPreloader({text: 'Идет удаление класса', showMenu: false}))
    const removeRequest = classApi.detachChildren(elClass.id, {
        user_id,
        disabled_by_student: disabledByStudent,
        disable_comment: disabledByStudent ? disableComment : '',
        keepUncompletedHomework
      })
      .then(
        (response) => ({ response, error: null }),
        (error) => ({ response: null, error }),
      )

    Promise.all([
      removeRequest,
      waitMinDeletePreloaderDelay(),
    ]).then(([result]) => {
        if (result.error) throw result.error

        const {data} = result.response
        if(data?.status === "success"){
            setClasses((prev)=>prev.filter(c => c.id !== elClass.id))
            fetchClasses()
            addAlert({ title: 'Класс успешно удален' });
            closeModal()
        }
        else{
            addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось удалить класс' });
        }
    })
    .catch((error) => {
      addAlert({
        type: 'error',
        title: 'Ошибка',
        text: error?.response?.data?.message ?? 'Не удалось удалить класс',
      })
    })
    .finally(()=> {
      setRemoving(false)
      dispatch(closePreloader())
    })
  }
 
  return <div className="modalAddeDepartment">
    <h2 className="modal__title">Удалить класс</h2>
    <div className={s.body}>
        <div className={s.wrapperCheckBoxLabel}>
          <CheckBoxLabel
            style={{marginTop: '10px'}}
            value={keepUncompletedHomework}
            onClick={() => setKeepUncompletedHomework((prevValue) => !prevValue)}
            label="Не удалять заданные (не выполненные) дз у ученика"
          />
        </div>
        <div className={s.wrapperCheckBoxLabel}>
          <CheckBoxLabel
              value={disabledByStudent}
              onClick={() => setDisabledByStudent((prevValue) => !prevValue)}
              label='Учащийся слился с обучения'
          />
        </div>
        
        {
            disabledByStudent && <div style={{width:'100%'}}>
              <span style={{fontSize:'15px', marginBottom:'10px', display:'flex'}}>Напишите причину слива учащегося</span>
              <Textarea
                value={disableComment} 
                onChange={e => setDisableComment(e.target.value)} 
                placeholder='Причина слива учащегося' 
                style={{width:'100%'}} />
            </div>
        }
      <Button 
        disabled={removing}
        isLoading={removing}    
        onClick={removeClass}>Подтвердить действие</Button>
    </div>
  </div>
}
export default ModalRemoveClass
